import React from "react";
import { FiLogOut, FiHelpCircle } from "react-icons/fi";
import MenuTerms from "newui/features/AppMenu/components/MenuTerms";
import logo from "../assets/logo.png";
import logoText from "../assets/logo-procuracon.svg";
import Tooltip from "components/Tooltip";

interface AppMenuFooterProps {
  isCollapsed: boolean;
  showHelp?: boolean;
  onLogout: () => void;
  onHelpClick?: () => void;
}

export const AppMenuFooter: React.FC<AppMenuFooterProps> = ({
  isCollapsed,
  onLogout,
  onHelpClick,
  showHelp = false,
}) => {
  return (
    <div>
      {/* Separator */}
      <div
        className="sidemuchild mx-2 mb-2"
        style={{ borderBottom: isCollapsed ? "solid 1px rgba(255,255,255,0.2)" : "solid 1px #EAECF0" }}
      />

      {/* Logout button */}
      {isCollapsed ? (
        <Tooltip label="Logout" placement="right" hasArrow shouldWrapChildren={false}>
          <button
            onClick={onLogout}
            className="flex w-full items-center justify-center py-3"
            data-testid="logout-button"
          >
            <FiLogOut size={20} color="#fff" />
          </button>
        </Tooltip>
      ) : (
        <button
          onClick={onLogout}
          className="group flex w-full items-center gap-3 px-6 py-3 hover:bg-utility-blue-light-50"
          data-testid="logout-button"
        >
          <FiLogOut size={20} color="#0045F5" />
          <span
            className="sidemuchild font-roboto group-hover:text-royal-blue"
            style={{ fontWeight: 500, lineHeight: "24px" }}
          >
            Logout
          </span>
        </button>
      )}

      {!isCollapsed && (
        <div
          className="sidemuchild mx-2 mb-2"
          style={{ borderBottom: "solid 1px #EAECF0" }}
        />
      )}

      {/* Logo + help */}
      {!isCollapsed ? (
        <div className="flex items-center justify-between px-5 pb-3 pt-6">
          <img
            src={logoText}
            alt="Procuracon Logo text"
            className="sidemuchild logolong"
            style={{ width: "154px", height: "24px" }}
          />
          {showHelp && onHelpClick && (
            <Tooltip label="Restart Guided Tour" placement="right" hasArrow shouldWrapChildren={false}>
              <button
                onClick={onHelpClick}
                className="bg-Colors-Brand-25/70 inline-flex h-8 items-center justify-start gap-2.5 rounded-full p-2"
                aria-label="Guided Tour"
              >
                <div className="GuidedTourIcon relative h-5 w-5 rounded-full p-1 hover:cursor-pointer hover:text-royal-blue">
                  <FiHelpCircle size={20} />
                </div>
              </button>
            </Tooltip>
          )}
        </div>
      ) : (
        <div className="flex flex-col items-center gap-2 py-2">
          {showHelp && onHelpClick && (
            <Tooltip label="Restart Guided Tour" placement="right" hasArrow shouldWrapChildren={false}>
              <button
                onClick={onHelpClick}
                className="inline-flex h-8 items-center justify-center rounded-full p-2"
                aria-label="Guided Tour"
              >
                <FiHelpCircle size={20} color="#fff" />
              </button>
            </Tooltip>
          )}
          <img
            src={logo}
            alt="Procuracon Logo"
            width="36"
            height="36"
          />
        </div>
      )}

      {!isCollapsed && <MenuTerms />}
    </div>
  );
};
